export default __webpack_public_path__ + "static/media/kofi.c8431e09.svg";